/**
 * Form values used by spot and mentions schedule listings.
 */
export type SchedulesListFilterValues = {
  from: string;
  to: string;
  customId: string;
  advertiser: string;
  campaign: string;
  version: string;
  order: string;
};

/**
 * Empty defaults for schedule metadata text filters.
 */
export const schedulesListMetadataDefaultValues = {
  advertiser: '',
  campaign: '',
  version: '',
  order: '',
} as const;

/**
 * Builds api-v2 CRUD filter strings for schedule listings from form values.
 */
export function buildSchedulesListCrudFilters(
  values: SchedulesListFilterValues,
  type: 'SPOT' | 'MENTION',
): string[] {
  const filters: string[] = [
    `type||$eq||${type}`,
    `datetime||$gte||${values.from}`,
    `datetime||$lte||${values.to}`,
  ];

  const customIds = values.customId
    ?.split(',')
    .map((v) => v.trim())
    .filter((v) => !!v);

  if (customIds?.length === 1) {
    filters.push(`customId||$eq||${customIds[0]}`);
  } else if (customIds && customIds.length > 1) {
    filters.push(`customId||$in||${customIds.join(',')}`);
  }

  const advertiser = values.advertiser?.trim();
  const campaign = values.campaign?.trim();
  const version = values.version?.trim();
  const order = values.order?.trim();

  if (advertiser) {
    filters.push(`advertiser||$eq||${advertiser}`);
  }

  if (campaign) {
    filters.push(`campaign||$eq||${campaign}`);
  }

  if (version) {
    filters.push(`version||$eq||${version}`);
  }

  if (order) {
    filters.push(`order||$eq||${order}`);
  }

  return filters;
}
